export default __webpack_public_path__ + "i18n/translations/translation-zh.8cb530f1.json";